/**
 * Component to Show Report List
 *
 *
 * @author Nihala Dilshi
 */

import { useState } from 'react';

import { Input, Table, Modal, Form } from 'antd';
import moment from 'moment';
import { EditOutlined, EyeOutlined, CloseCircleFilled } from '@ant-design/icons';
import { Tag, Card, useTranslation, Button } from 'soxo-bootstrap-core';

export default function ReportList({ callback, template, medicalReport, cancelReport, cancelReportModalVisible, setCancelReportModalVisible,aiReportEditDisable }) {
    const { TextArea } = Input;
    const [selectedRecord, setSelectedRecord] = useState({});
    const { t } = useTranslation(); // To Translate to another language

    const ReportListColumns = [
        {
            title: '#',
            dataIndex: 'index',
            render: (_, __, index) => index + 1,
        },

        {
            title: t('ID'),
            render: (ele) => {
                return <div>{ele.id}</div>;
            },
            key: 'id',
        },
        {
            title: t('Date'),

            render: (ele) => {
                return ele.date ? moment.tz(ele.date, '').format('DD/MM/YYYY hh:mm a') : null;
            },

            key: 'date',
            width: 150,
        },

        {
            title: t('Report'),
            render: (ele) => {
                return <div>{ele.report_name}</div>;
            },
            key: 'report',
            width: 150,
        },
        {
            title: t('Status'),

            render: (ele) => <Tag color={ele.status === 'D' ? 'blue' : 'green'}>{ele.status === 'D' ? 'Draft' : 'Sign Off'}</Tag>,
            key: 'status',
        },

        {
            title: <div style={{ textAlign: 'center', width: '100%' }}>{t('Action')}</div>,
            fixed: 'center',
            align: 'left',
            render: (ele) => {
                return (
                    <>
                        {ele.status === 'D' ? (
                            <Button
                                type="secondary"
                                key="edit"
                                htmlType="submit"
                                style={{ marginLeft: '20px', color: 'black', width: '100px' }}
                                onClick={() => callback(ele, 'edit')}
                                disabled={aiReportEditDisable} 
                            >
                                <EditOutlined /> {t('Edit')}
                            </Button>
                        ) : null}
                        <Button
                            type="secondary"
                            key="view"
                            htmlType="submit"
                            style={{ marginLeft: '20px', color: 'black', width: '100px' }}
                            onClick={() => callback(ele, 'view')}
                        >
                            <EyeOutlined />
                            {t('View')}
                        </Button>
                        <Button
                            type="secondary"
                            key="cancel"
                            htmlType="submit"
                            style={{ marginLeft: '20px', color: 'black', width: '100px' }}
                            onClick={() => {
                                setSelectedRecord(ele);
                                setCancelReportModalVisible(true);
                            }}
                            disabled={aiReportEditDisable} 
                        >
                            <CloseCircleFilled /> {t('Cancel')}
                        </Button>
                    </>
                );
            },
            key: 'action',
        },
    ];

    return (
        <>
            <div className="detail-element">
                <Card className="table-card">
                    <Table
                        scroll={{ x: 'max-content' }}
                        rowKey={(key) => key}
                        pagination={false}
                        dataSource={Array.isArray(medicalReport) ? medicalReport : []}
                        columns={ReportListColumns}
                    />
                </Card>
                {/**----Modal for Report Cancellation Starts----- */}
                <Modal
                    destroyOnClose={true}
                    footer={null}
                    title="Cancel Report"
                    visible={cancelReportModalVisible}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    onCancel={() => {
                        setCancelReportModalVisible(false);
                    }}
                >
                    <Form onFinish={(values) => cancelReport(values, selectedRecord)}>
                        <Form.Item
                            name="remarks"
                            label="Remarks"
                            rules={[
                                { required: true, message: 'Remarks are required' },
                                { max: 50, message: 'Remarks cannot exceed 50 characters' },
                            ]}
                        >
                            <TextArea />
                        </Form.Item>
                        <Button htmlType="submit">Proceed to Cancel Report</Button>
                    </Form>
                </Modal>
                {/**----Modal for Report Cancellation Ends----- */}
            </div>
        </>
    );
}
